import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./PlayerDetails.css";

const PlayerDetails = () => {

  const { email } = useParams();
  const navigate = useNavigate();

  const [player, setPlayer] = useState(null);

  useEffect(() => {
    loadPlayer();
  }, [email]);

  const loadPlayer = async () => {

    try {

      const profileRes = await axios.get(
        `/api/admin/player/${email}`
      );

      const summaryRes = await axios.get(
        `/api/admin/player-best-summary/${email}`
      );

      setPlayer({
        profile: profileRes.data.profile,
        summary: summaryRes.data
      });

    } catch (err) {

      console.error(err);

    }

  };

  if (!player) {
    return <h2>Loading...</h2>;
  }

  return (
    <div className="player-details">

      <h1>Player Details</h1>

      <div className="profile-card">

        <h2>
          {player.profile?.name || "Unknown"}
        </h2>

        <p>
          {player.profile?.email || "-"}
        </p>

        <p>
          Status: {player.profile?.status || "-"}
        </p>

        <p>
          Phone: {player.profile?.phone || "-"}
        </p>

        <button
          className="history-btn"
          onClick={() =>
            navigate(
              `/admin-playerhistory/${encodeURIComponent(email)}`
            )
          }
        >
          View Full History
        </button>

      </div>

      <div className="stats-grid">

        <div className="stat-card">
          <h3>Reaction Best</h3>
          <p>
            {player.summary?.reactionBest
              ? Math.round(
                  player.summary.reactionBest * 1000
                )
              : 0} ms
          </p>
        </div>

        <div className="stat-card">
          <h3>Reaction Avg</h3>
          <p>
            {player.summary?.reactionAverage
              ? Math.round(
                  player.summary.reactionAverage * 1000
                )
              : 0} ms
          </p>
        </div>

        <div className="stat-card">
          <h3>Complex Best</h3>
          <p>
            {player.summary?.complexBest
              ? Math.round(
                  player.summary.complexBest * 1000
                )
              : 0} ms
          </p>
        </div>

        <div className="stat-card">
          <h3>Search Span</h3>
          <p>
            {player.summary?.searchSpanBest || 0}
          </p>
        </div>

        <div className="stat-card">
          <h3>Working Memory</h3>
          <p>
            {player.summary?.workingMemoryBest || 0}
          </p>
        </div>

        <div className="stat-card">
          <h3>Short Memory</h3>
          <p>
            {player.summary?.shortMemoryBest || 0}
          </p>
        </div>

        <div className="stat-card">
          <h3>Anticipation</h3>
          <p>
            {player.summary?.anticipationBest || 0}
          </p>
        </div>
        <div className="stat-card">
          <h3>Visual Acuity</h3>
          <p>
            {player.summary?.visualAcuityBest || "-"}
          </p>
        </div>
      </div>

    </div>
  );
};

export default PlayerDetails;